// extracted by mini-css-extract-plugin
export default {"point":"Point_point__huTIr","dots":"Point_dots__YvKpR","dotsBg":"Point_dotsBg__BaQLw","title":"Point_title__AFkhe"};